import React from 'react';
import InputRange from 'react-input-range';

const LevelFilter = React.createClass({

    getInitialState: function() {
        return ({
            values: {
                min: this.props.minValue,
                max: this.props.maxValue,
            }
        })
    },

    render: function(){

        return (
            <div className="level--filter">
                <span>{ this.props.name } :</span>
                <InputRange
                    maxValue = { this.props.maxValue }
                    minValue = { this.props.minValue }
                    value = { this.state.values }
                    onChange = { this.handleChange.bind(this) }
                />
            </div>
        );

    },

    handleChange: function( component, values ) {
        this.setState({
            values: values,
        });
    }

});

export default LevelFilter;


/** WEBPACK FOOTER **
 ** ./app/LevelFilter.jsx
 **/